<ng-template #expandedView>
    <form class="settings-page" [formGroup]="form" (submit)="onSubmit()">
        <form-errors></form-errors>

        <div class="settings-page__list">
            <!--<div class="settings-page__item settings-page__item&#45;&#45;default-page">
                <p class="txt-sm">Default page</p>
                <div class="default-main__list">
                    <div class="default-main__item">
                        <input type="radio" name="DefaultMainPage"
                               [value]="'monetization'"
                               id="monetization"
                               class=""
                               formControlName="DefaultMainPage"
                        >
                        <label for="monetization" class="txt-sm">Monetization</label>
                    </div>
                    <div class="default-main__item">
                        <input type="radio" name="DefaultMainPage"
                               [value]="'overview'"
                               id="overview"
                               class=""
                               formControlName="DefaultMainPage"
                        >
                        <label for="overview" class="txt-sm">Overview</label>
                    </div>
                    <div class="default-main__item">
                        <input type="radio" name="DefaultMainPage"
                               [value]="'reports'"
                               id="reports"
                               class=""
                               formControlName="DefaultMainPage"
                        >
                        <label for="reports" class="txt-sm">Reports</label>
                    </div>
                </div>
            </div>-->
            <div class="settings-page__item">
                <p class="txt-sm">{{ 'analytics.monetization.settings.theme.title' | i18next }}</p>
                <div class="default-main__list">
                    <div class="default-main__item">
                        <input
                            type="radio"
                            name="MonetizationTheme"
                            [value]="ThemeType.CLASSIC"
                            id="classic"
                            class="hidden"
                            formControlName="MonetizationTheme"
                        />
                        <label for="classic">
                            <div class="default-main__img">
                                <i class="icn--check-thin"></i>
                                <img src="/assets/images/theme/classic.svg" alt="" />
                            </div>
                            <p class="default-main__txt">{{ 'analytics.monetization.settings.theme.type.classic' | i18next }}</p>
                        </label>
                    </div>

                    <div class="default-main__item">
                        <input
                            type="radio"
                            name="MonetizationTheme"
                            [value]="ThemeType.NEW"
                            id="new"
                            class="hidden"
                            formControlName="MonetizationTheme"
                        />
                        <label for="new">
                            <div class="default-main__img">
                                <i class="icn--check-thin"></i>
                                <img src="/assets/images/theme/new.svg" alt="" />
                            </div>
                            <p class="default-main__txt">{{ 'analytics.monetization.settings.theme.type.new' | i18next }}</p>
                        </label>
                    </div>
                </div>
            </div>
            <!--<div class="settings-page__item">
                <p class="txt-sm">Tooltip VIEW MODE</p>
                <div class="default-main__list">
                    <div class="default-main__item">
                        <input type="radio" name="isTooltipViewMode"
                               [value]="'together'"
                               id="together"
                               class="hidden"
                               formControlName="isTooltipViewMode"
                        >
                        <label for="together">
                            <div class="default-main__img">
                                <i class="icn&#45;&#45;check-thin"></i>
                                <img src="/assets/images/theme/classic.svg" alt="">
                            </div>
                            <p class="default-main__txt">Categories together</p>
                        </label>
                    </div>
                    <div class="default-main__item">
                        <input type="radio" name="isTooltipViewMode"
                               [value]="'oneByOne'"
                               id="oneByOne"
                               class="hidden"
                               formControlName="isTooltipViewMode"
                        >
                        <label for="oneByOne">
                            <div class="default-main__img">
                                <i class="icn&#45;&#45;check-thin"></i>
                                <img src="/assets/images/theme/new.svg" alt="">
                            </div>
                            <p class="default-main__txt">Classic<br>one-by-one</p>
                        </label>
                    </div>
                </div>
            </div>
            <div class="settings-page__item settings-page__item&#45;&#45;other">
                <p class="txt-sm">Other</p>
                <div class="default-main__list">
                    <div class="default-main__item">
                        <checkbox name="isOtherSettings"
                                  id="showDau"
                                  formControlName="isOtherSettings"
                        >Show DAU in Revenue chart</checkbox>
                    </div>
                    <div class="default-main__item">
                        <checkbox name="isOtherSettings"
                                  id="showArpdau"
                                  formControlName="isOtherSettings"
                        >Show ARPDAU in Revenue chart</checkbox>
                    </div>
                    <div class="default-main__item">
                        <checkbox name="isOtherSettings"
                                  id="relativeDate"
                                  formControlName="isOtherSettings"
                        >Use relative date in calendar</checkbox>
                    </div>
                </div>
            </div>-->
        </div>
        <div class="settings-page__list">
            <div class="settings-page__item">
                <p class="txt-sm">{{ 'analytics.monetization.settings.chartTopLimit' | i18next }}</p>
                <div class="default-main__list">
                    <number-input formControlName="chartTopLimit"></number-input>
                </div>
            </div>
        </div>
        <div class="settings-page__list">
            <div class="settings-page__item">
                <p class="txt-sm">
                    {{ 'analytics.monetization.settings.hideEmptySeries' | i18next }}
                </p>
                <div class="default-main__list">
                    <tumbler formControlName="hideEmptySeries"></tumbler>
                </div>
            </div>
        </div>

        <div class="settings-page__list">
            <div class="settings-page__item">
                <p class="txt-sm">
                    {{ 'analytics.monetization.settings.showMissingPoints' | i18next }}
                </p>
                <div class="default-main__list">
                    <tumbler formControlName="showMissingPoints"></tumbler>
                </div>
            </div>
        </div>

        <div class="feedback-popup__btns">
            <button type="submit" class="button button--small button--primary" [class.loading]="formService.pending$ | async">
                {{ 'analytics.monetization.settings.theme.save' | i18next }}
            </button>
            <button type="button" class="button button--small button--cancel" (click)="hideSettingsDropdown()">
                {{ 'analytics.monetization.settings.theme.cancel' | i18next }}
            </button>
        </div>
    </form>
</ng-template>

<div dropDown [optionsTemplate]="expandedView" class="fa fa-cog"></div>
